import { buildGroupPage } from "discourse/routes/group/activity/posts";
import { i18n } from "discourse-i18n";

const type = "posts";
const GroupPostsRoute = buildGroupPage("posts");

export default class CircleActivityPostsRoute extends GroupPostsRoute {
  titleToken() {
    const filterText = i18n("filters.latest.title");

    return i18n("discourse_circles.circle.activity.title_token.posts", {
      circle_name: this.modelFor("circle").name,
      filter: filterText,
    });
  }

  model() {
    const circleModel = this.modelFor("circle");

    const categoryId = circleModel.category_id;
    const group = circleModel.member_group;

    return group.findPosts({ type, categoryId });
  }
}
